export const TRIAS_VERSION = '1.4';
export const TRIAS_NAMESPACE = 'http://www.vdv.de/trias';
export const SIRI_NAMESPACE = 'http://www.siri.org.uk/siri';
export const XML_SCHEMA_2001 = 'http://www.w3.org/2001/XMLSchema';
export const XML_SCHEMA_INSTANCE_2001 =
  'http://www.w3.org/2001/XMLSchema-instance';
